import { Box, Typography, Button, Link } from "@mui/material";
import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import PhoneIcon from "@mui/icons-material/Phone";
import { useAnimation } from "../contexts/AnimationContext";

function Taxis() {
  const ref = useRef(null);
  const { animationStarted } = useAnimation();
  const isInView = useInView(ref, { once: true, margin: "0px" });

  return (
    <Box
      component={motion.div}
      ref={ref}
      initial={{ opacity: 0, y: 30 }}
      animate={
        isInView && animationStarted
          ? { opacity: 1, y: 0 }
          : { opacity: 0, y: 30 }
      }
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      sx={{
        mt: 6,
        mb: 0,
        justifyContent: "center",
        textAlign: "center",
        alignContent: "center",
      }}
    >
      <Typography
        variant="h5"
        sx={{
          fontFamily: '"Open Sans", sans-serif',
          fontSize: { xs: "1.35rem", sm: "1.5rem" },
          fontWeight: 400,
          color: "#1a3a52",
          mb: 3,
          textAlign: { xs: "center", md: "center" },
          // ml: { md: 7 },
        }}
      >
        Táxis
      </Typography>

      {/* Cooptáxis */}
      <Box sx={{ mb: 3 }}>
        <Typography
          variant="h6"
          sx={{
            fontFamily: '"Open Sans", sans-serif',
            fontSize: { xs: "1.1rem", sm: "1.2rem" },
            fontWeight: 500,
            color: "#1a3a52",
            mb: 1,
          }}
        >
          Cooptáxis (Lisboa)
        </Typography>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            mb: 1.5,
            justifyContent: "center",
            textAlign: "center",
            alignContent: "center",
          }}
        >
          <Link
            href="tel:+351217932756"
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 0.5,
              textDecoration: "none",
              color: "#1a3a52",
              "&:hover": {
                color: "#2d4e66",
              },
              justifyContent: "center",
              textAlign: "center",
              alignContent: "center",
            }}
          >
            <PhoneIcon sx={{ fontSize: { xs: "1rem", sm: "1.1rem" } }} />
            <Typography
              variant="body2"
              sx={{
                fontFamily: '"Open Sans", sans-serif',
                fontSize: { xs: "0.95rem", sm: "1rem" },
              }}
            >
              +351 217 932 756
            </Typography>
          </Link>
        </Box>
        <Button
          component="a"
          href="https://cooptaxis.pt/"
          target="_blank"
          rel="noopener noreferrer"
          variant="outlined"
          sx={{
            fontFamily: '"Open Sans", sans-serif',
            fontSize: "0.85rem",
            fontWeight: 500,
            color: "#1a3a52",
            borderColor: "#1a3a52",
            textTransform: "none",
            px: 3,
            py: 1,
            width: "160px",
            "&:hover": {
              borderColor: "#1a3a52",
              backgroundColor: "rgba(26, 58, 82, 0.04)",
            },
          }}
        >
          Website
        </Button>
      </Box>

      {/* Óscar Taxi */}
      <Box sx={{ mb: 3 }}>
        <Typography
          variant="h6"
          sx={{
            fontFamily: '"Open Sans", sans-serif',
            fontSize: { xs: "1.1rem", sm: "1.2rem" },
            fontWeight: 500,
            color: "#1a3a52",
            mb: 1,
          }}
        >
          Óscar Taxi (Alenquer)
        </Typography>
        <Box sx={{ mb: 1.5 }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              mb: 0.5,
              justifyContent: "center",
              textAlign: "center",
              alignContent: "center",
            }}
          >
            <Link
              href="tel:+351965625148"
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 0.5,
                textDecoration: "none",
                color: "#1a3a52",
                "&:hover": {
                  color: "#2d4e66",
                },
              }}
            >
              <PhoneIcon sx={{ fontSize: { xs: "1rem", sm: "1.1rem" } }} />
              <Typography
                variant="body2"
                sx={{
                  fontFamily: '"Open Sans", sans-serif',
                  fontSize: { xs: "0.95rem", sm: "1rem" },
                }}
              >
                +351 965 625 148
              </Typography>
            </Link>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              mb: 0.5,
              justifyContent: "center",
              textAlign: "center",
              alignContent: "center",
            }}
          >
            <Link
              href="tel:+351917509104"
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 0.5,
                textDecoration: "none",
                color: "#1a3a52",
                "&:hover": {
                  color: "#2d4e66",
                },
                justifyContent: "center",
                textAlign: "center",
                alignContent: "center",
              }}
            >
              <PhoneIcon sx={{ fontSize: { xs: "1rem", sm: "1.1rem" } }} />
              <Typography
                variant="body2"
                sx={{
                  fontFamily: '"Open Sans", sans-serif',
                  fontSize: { xs: "0.95rem", sm: "1rem" },
                }}
              >
                +351 917 509 104
              </Typography>
            </Link>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              justifyContent: "center",
              textAlign: "center",
              alignContent: "center",
            }}
          >
            <Link
              href="tel:+351937730039"
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 0.5,
                textDecoration: "none",
                color: "#1a3a52",
                "&:hover": {
                  color: "#2d4e66",
                },
              }}
            >
              <PhoneIcon sx={{ fontSize: { xs: "1rem", sm: "1.1rem" } }} />
              <Typography
                variant="body2"
                sx={{
                  fontFamily: '"Open Sans", sans-serif',
                  fontSize: { xs: "0.95rem", sm: "1rem" },
                }}
              >
                +351 937 730 039
              </Typography>
            </Link>
          </Box>
        </Box>
        <Button
          component="a"
          href="https://www.oscartaxi.pt/"
          target="_blank"
          rel="noopener noreferrer"
          variant="outlined"
          sx={{
            fontFamily: '"Open Sans", sans-serif',
            fontSize: "0.85rem",
            fontWeight: 500,
            color: "#1a3a52",
            borderColor: "#1a3a52",
            textTransform: "none",
            px: 3,
            py: 1,
            width: "160px",
            "&:hover": {
              borderColor: "#1a3a52",
              backgroundColor: "rgba(26, 58, 82, 0.04)",
            },
          }}
        >
          Website
        </Button>
      </Box>
    </Box>
  );
}

export default Taxis;
